/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_FocusInputs */

const en_landing_why_focus = /** @type {(inputs: Landing_Why_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus`)
};

const zh_landing_why_focus = /** @type {(inputs: Landing_Why_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心能力`)
};

/**
* | output |
* | --- |
* | "Focus" |
*
* @param {Landing_Why_FocusInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_focus = /** @type {((inputs?: Landing_Why_FocusInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_FocusInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_focus(inputs)
	return zh_landing_why_focus(inputs)
});
export { landing_why_focus as "landing.why.focus" }